// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fcaddd2b","453":"8ab44547","553":"b0f52eb6","977":"c7cbf7c7"}[chunkId] + ".chunk.js";
};